import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
import { CircularProgress, CssBaseline } from '@mui/material';
import { Grid } from '@mui/material';

import store from './store';
import { GlobalProvider, useGlobalContext } from './context/GlobalContext';
import themes from './themes';
import { THEMES } from './configs';
import Routes from './routes/Routes';
import Alert from './Layout/shared/common/alert';

function App() {
  const { modeTheme } = useGlobalContext();
  const type = modeTheme === THEMES.LIGHT ? 0 : 1;
  return (
    <Provider store={store}>
      <GlobalProvider>
        <ThemeProvider theme={themes(type)}>
          <CssBaseline />
          <SnackbarProvider
            autoHideDuration={process.env.REACT_APP_AUTO_HIDE_SNACKBAR || 3000}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <Suspense
              fallback={
                <Grid
                  sx={{
                    display: 'flex',
                    minWidth: 0,
                    alignItems: 'center',
                    alignContent: 'center',
                    height: '100%',
                  }}
                >
                  <CircularProgress sx={{ m: '-40px auto 0' }} />
                </Grid>
              }
            >
              <Routes />
            </Suspense>
            <Alert />
          </SnackbarProvider>
        </ThemeProvider>
      </GlobalProvider>
    </Provider>
  );
}

export default App;
